import { inject, Injectable } from '@angular/core';
import { FormGridConfigBase } from '../models/form-grid-config-base';
import { FormGridGroupConfigBase } from '../models/form-grid-group-config-base';
import { FormGridInstanceStore } from './form-grid-instance.store';

@Injectable()
export class FormGridModeService {
  private readonly store = inject(FormGridInstanceStore);
  private config: FormGridConfigBase | null = null;

  initialize(config: FormGridConfigBase): void {
    this.config = config;
  }

  enterEdit(entityKey: string, formType: string): void {
    const group = this.group(formType);
    if (group?.editCreatesNewEntry) {
      this.store.setDate(entityKey, formType, new Date());
    }
    this.store.setMode(entityKey, formType, 'edit');
  }

  enterReadonly(entityKey: string, formType: string): void {
    this.store.setMode(entityKey, formType, 'readonly');
  }

  enterAdd(entityKey: string, formType: string): void {
    const group = this.group(formType);
    const form = group && this.config ? group.form(this.config.context) : null;
    if (!form || !this.store.hasInstance(entityKey, formType)) {
      return;
    }
    this.store.swapBridge(entityKey, formType, form, 'add');
    this.store.setDate(entityKey, formType, new Date());
    this.store.setMode(entityKey, formType, 'add');
  }

  clearForm(entityKey: string, formType: string): void {
    const group = this.group(formType);
    const form = group && this.config ? group.form(this.config.context) : null;
    if (!form || !this.store.hasInstance(entityKey, formType)) {
      return;
    }
    this.store.swapBridge(entityKey, formType, form, this.store.mode(entityKey, formType));
  }

  showTodayLabel(entityKey: string, formType: string): boolean {
    const mode = this.store.mode(entityKey, formType);
    if (mode === 'add') {
      return true;
    }
    return !!this.group(formType)?.editCreatesNewEntry && mode === 'edit';
  }

  private group(formType: string): FormGridGroupConfigBase | undefined {
    return this.config?.formGroups.find((g) => g.type === formType);
  }
}
